import React from 'react';
import Confirmation from './modals/common/Confirmation';
import { Description } from './Description';
import { FormInformationDialog } from './FormInformationDialog';
import { messageUtility } from '../utilities/messageUtility';
import dialogLoader from '../utilities/dialogLoader';
import warningIcon from '../images/icon/warning-24px.svg';
import { EXISTANCE_EXCLUSION_FLAG } from '../utilities/constants';
import { isNullOrUndefinedOrEmptyStr } from '../utilities/stringUtil';

/**
 * 作業員、会社情報の既存データ対応の共通UI Component
 */

const stringJudgmentForSubscriptionStatus = flag => {
  switch (flag) {
    case EXISTANCE_EXCLUSION_FLAG.EXIST.ID:
      return '有';
    case EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID:
      return '適用除外';
    case EXISTANCE_EXCLUSION_FLAG.NOEXIST.ID:
      return '無';
    default:
      return '未選択';
  }
};

export const AttentionBox = ({
  isInsuranceInfo = false,
  flags,
  healthInsuranceData,
  pensionData,
  employmentData,
}) => {
  const { healthInsuranceFlag, pensionFlag, employmentInsuranceFlag } = flags;
  const pensionLabelList = {
    pension_reason_exclusion: '適用除外理由',
    pension_type: '保険種類',
    pension_insurance_expiration_date: '有効期限',
    pension_office_symbol: '事業所整理記号',
    pension_office_number: '事業所番号',
    // pension_type_exist: '加入状況 有の場合、保険種類は厚生年金になります。',
    // pension_type_exclusion:
    //   '加入状況 適用除外の場合、保険種類は国民年金を選択してください。',
  };

  const healthInsuranceLabelList = {
    health_insurance_reason_exclusion: '適用除外理由',
    health_insurance_type: '保険種類',
    health_insurance_name_insurer: isInsuranceInfo ? '保険者名' : '保険者名称',
    health_insurance_expiration_date: '有効期限',
    health_insurance_office_symbol: '事業所整理記号',
    health_insurance_office_number: '事業所番号',
  };

  const employmentInsuraceLabelList = {
    employment_insurance_type: '被保険者種類',
    employment_insurance_insurance_number: '労働保険番号', // 会社側
    employment_insurance_reason_exclusion: '適用除外理由',
    employment_insurance_insured_number: '被保険者番号', // 作業員側
  };

  const renderCurrentSelectionOfsubscriptionStatus = ({ type, flag }) => {
    let targetInsuranceName = '';
    switch (type) {
      case 'healthInsurance':
        targetInsuranceName = isInsuranceInfo ? '健康保険' : '健康保険情報';
        break;
      case 'pension':
        targetInsuranceName = isInsuranceInfo ? '年金' : '年金保険情報';
        break;
      case 'employmentInsurance':
        targetInsuranceName = isInsuranceInfo ? '雇用保険' : '雇用保険情報';
        break;
      default:
        break;
    }

    if (isNullOrUndefinedOrEmptyStr(flag)) {
      return (
        <React.Fragment>
          <p>
            <span className='AttentionBox__label'>
              {targetInsuranceName} 加入状況が 未選択状態です。
            </span>
          </p>
          <p>加入状況を切り替えることで以下項目が表示されます。</p>
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <p>
          <span className='AttentionBox__label'>
            {targetInsuranceName} 加入状況で現在{' '}
            {stringJudgmentForSubscriptionStatus(flag)}
            が選択されています。
          </span>
        </p>
        <p>加入状況を切り替えることで以下項目が表示されます。</p>
      </React.Fragment>
    );
  };
  return (
    <Description type='warning'>
      <div className='AttentionBox'>
        <div>
          <p>
            2021年10月24日の定期メンテナンスにて社会保険加入情報の入力が適切に行えるようシステム改修を行いました。
          </p>
          <p>
            これに伴い加入状況の「無」「有」「適用除外」の選択内容によって必要な入力項目が自動で表示されるようになりました。
          </p>
          <p>
            また、選択中の加入状況に対して不要な入力項目については非表示になりました。
          </p>
          <br />
          <p>
            お客様がこれまでに選択された加入状況に対して非表示の入力項目があります。
          </p>
          <p>
            現在画面に表示されている社会保険加入情報が正しいかご確認のうえ更新をお願いいたします。
          </p>
          <br />
          <p>なお、更新すると非表示の項目に登録された内容は削除されます。</p>
          <br />
        </div>
        <div className='AttentionBox__title'>非表示になっている入力項目</div>
        {healthInsuranceData.length > 0 && (
          <div className='AttentionBox__block'>
            {renderCurrentSelectionOfsubscriptionStatus({
              type: 'healthInsurance',
              flag: healthInsuranceFlag,
            })}
            <div className=''>
              <ul>
                {healthInsuranceData.map((item, index) => {
                  if (healthInsuranceLabelList[item]) {
                    return (
                      <AttensionBoxListItem key={index}>
                        {healthInsuranceLabelList[item]}
                      </AttensionBoxListItem>
                    );
                  }
                })}
              </ul>
            </div>
          </div>
        )}
        {pensionData.length > 0 && (
          <div className='AttentionBox__block'>
            {renderCurrentSelectionOfsubscriptionStatus({
              type: 'pension',
              flag: pensionFlag,
            })}
            <div className=''>
              <ul>
                {pensionData.map((item, index) => {
                  if (pensionLabelList[item]) {
                    return (
                      <AttensionBoxListItem key={index}>
                        {pensionLabelList[item]}
                      </AttensionBoxListItem>
                    );
                  }
                })}
              </ul>
            </div>
          </div>
        )}
        {employmentData.length > 0 && (
          <div className='AttentionBox__block'>
            {renderCurrentSelectionOfsubscriptionStatus({
              type: 'employmentInsurance',
              flag: employmentInsuranceFlag,
            })}
            <div className=''>
              <ul>
                {employmentData.map((item, index) => {
                  if (employmentInsuraceLabelList[item]) {
                    return (
                      <AttensionBoxListItem key={index}>
                        {employmentInsuraceLabelList[item]}
                      </AttensionBoxListItem>
                    );
                  }
                })}
              </ul>
            </div>
          </div>
        )}
      </div>
    </Description>
  );
};

const AttensionBoxListItem = ({ children }) => {
  return <li className='AttentionBox__item'>{children}</li>;
};

export const ApprovalDialog = props => {
  const { title, message, onClose, onConfirm } = props.dialog || {};
  return (
    <Confirmation
      visible={true}
      title={title}
      message={message}
      confirmButtonText={'更新する'}
      cancelButtonText={messageUtility.getMessage('I-000-008')}
      onConfirm={onConfirm}
      onCancel={onClose}
      multilineText={true}
    />
  );
};

/**
 * 社会保険に未表示データがある場合に表示する情報更新お願いダイアログを表示する
 * @props {array} healthNoticeData 健康保険のうち非表示になっている項目のリスト
 * @props {array} pensionNoticeData 年金のうち非表示になっている項目のリスト
 * @props {array} employmentNoticeData 雇用保険のうち非表示になっている項目のリスト
 */
export const showFixedDataAnnouncementDialog = (
  healthNoticeData,
  pensionNoticeData,
  employmentNoticeData
) => {
  let displayMessage = '';
  if (healthNoticeData.length > 0) {
    displayMessage = '健康保険';
  }
  if (pensionNoticeData.length > 0) {
    if (displayMessage.length > 0) {
      displayMessage += '、';
    }
    displayMessage += '年金';
  }
  if (employmentNoticeData.length > 0) {
    if (displayMessage.length > 0) {
      displayMessage += '、';
    }
    displayMessage += '雇用保険';
  }

  const renderTitle = () => {
    return (
      <div className='data-announcement-dialog__title'>
        <img src={warningIcon} className='warning-icon' />
        ご登録情報の確認のお願い
      </div>
    );
  };
  const message = `お客様が登録されている各種保険情報内に確認いただきたいデータがございます。\n閉じるボタン押下後、赤枠内に詳細が表示されますのでそちらをご確認のうえ編集を行ってください。`;

  dialogLoader.show(FormInformationDialog, {
    title: renderTitle(),
    message,
    onClose: () => {
      dialogLoader.close();
    },
  });
};

export const showUserFixApprovalDialog = ({ onConfirm }) => {
  const renderTitle = () => {
    return (
      <div className='data-announcement-dialog__title'>
        <img src={warningIcon} className='warning-icon' />
        データ更新のご確認
      </div>
    );
  };
  const renderMessage = () => {
    return (
      <div>
        <p>
          現在画面に表示されている社会保険加入情報で登録されます。このまま更新してもよろしいでしょうか。
        </p>

        <br />
        <p>更新すると非表示の項目に登録された内容は削除されます。</p>
      </div>
    );
  };
  dialogLoader.show(ApprovalDialog, {
    title: renderTitle(),
    message: renderMessage(),
    onConfirm: () => {
      dialogLoader.close();
      onConfirm();
    },
    onClose: () => {
      dialogLoader.close();
    },
  });
};



// WEBPACK FOOTER //
// ./src/components/UserFixDataAttentionComponents.jsx